export enum EnumTypeProduct {
  CIRCUIT = 'CIRCUIT',
  COMBINED = 'COMBINED',
  HOTEL = 'HOTEL',
  AUTOTOUR = 'AUTOTOUR',
  RESIDENCE = 'RESIDENCE'
}
